import { render, staticRenderFns } from "./VirtualAssistantEventsReasonsTable.vue?vue&type=template&id=3cffe7ba&scoped=true&"
import script from "./VirtualAssistantEventsReasonsTable.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistantEventsReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistantEventsReasonsTable.vue?vue&type=style&index=0&id=3cffe7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffe7ba",
  null
  
)

export default component.exports